const getCurrentDate = (): string => {
  const date: Date = new Date()
  const seconds: string =
    date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds().toString()
  const minutes: string =
    date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes().toString()
  const hours: string = date.getHours() < 10 ? '0' + date.getHours() : date.getHours().toString()
  const day: string = date.getDate() < 10 ? '0' + date.getDate() : date.getDate().toString()
  const month: string =
    date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : (date.getMonth() + 1).toString()
  const year: string = date.getFullYear().toString()
  return `${day}.${month}.${year} | ${hours}:${minutes}:${seconds}`
}

export default getCurrentDate
